// dependencies
import { useContext, useEffect } from 'react';
import { ThemeContext } from '../ThemeContext';

// assets
import Sparkle from "../assets/icons/sparkle.svg";
import SparkleDark from "../assets/icons/sparkle-dark.svg";
import AboutPhoto from "../assets/images/jihan.png"

// components
import Skills from "./about/Skills";
import Competencies from "./about/Competencies";
import Recommendation from "./about/Recommendation";
import Experience from "./about/Experience";

function About() {
    const { darkTheme } = useContext(ThemeContext);

    useEffect(() => {
        const sparkleImages = document.querySelectorAll('img[alt="Sparkle"]');
        if (darkTheme) {
            sparkleImages.forEach(img => img.src = SparkleDark);
        } else {
            sparkleImages.forEach(img => img.src = Sparkle);
        }
    }, [darkTheme]);

    useEffect(() => {
        document.title = "About | Jihan Duerme - UI/UX Design & Web Development";
    }, []);

    return (
        <main>
            {/* Hero Banner */}
            <section className="about-hero">
                <article>
                    <div className="d-flex mb-4">
                        <img src={Sparkle} alt="Sparkle" />
                        <h2>About</h2>
                    </div>
                    <h1 className="mb-3">I design to bring out the best in the brands I work with and share it with the world</h1>
                    <p>I'm Jihan Duerme, a multidisciplinary UI/UX designer with over 10 years of experience creating digital products that solve real business problems.</p>
                    <p>I focus on critical thinking, intentional decisions, and collaboration. Working closely with cross-functional teams, I've learned to navigate ambiguity and focus on the <em>why</em> behind every choice. This approach lets me contribute across the full product lifecycle, from concept to launch, independently or collaboratively.</p>
                </article>
                <img src={AboutPhoto} alt="Jihan Duerme" />
            </section>
            <Skills />
            <Competencies />
            <Recommendation />
            <Experience />
        </main>
    );
};

export default About;